// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.suggestion-box-wrapper {\n  position: relative;\n  right: 0;\n  top: 0;\n  margin: 0;\n  padding: 0;\n}\n.suggestion-box {\n  position: absolute;\n  list-style: none;\n  border: 1px solid black;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  background-color: white;\n}\n.suggestion-add-task {\n  width: 100%;\n  margin: 0;\n  padding: 1em 0.5em;\n}\n.suggestion-add-task:hover {\n  background-color: #6080ff;\n}\n", ""]);
// Exports
module.exports = exports;
